export default __webpack_public_path__ + "static/media/spotify_white.25f6d0ec.png";